<template>
  <div class="zbList" @click="handleDetial(data)">
	<img class="zbList-img" :src="data.backgroundUrl" alt="" />
	<img v-if="type == 1" class="zbList-del" src="../../assets/image/shanchu_18@2x.png" alt="" @click.stop="handleDelete(data)" />
	<div class="zbList-box">
		<div class="zbList-box-fl-box">
			<div class="zbList-box-fl">{{data.categoryName}}</div>
		</div>
		<div class="zbList-box-zbjl" v-if="type == 1">
			<div class="zbList-box-zbjl-top">
				<span class="zbList-box-zbjl-left-span">{{data.name}}</span>
				
				<div class="zbList-box-zbjl-right" v-if="data.isOpenReplay == 1 && data.replayUrl" @click.stop="handlePlayVideo(data.replayUrl)">
					<img src="../../assets/image/huifang@2x.png" alt=""/>
					<span>{{$t('all.huifang')}}</span>
				</div>
			</div>
			<span class="zbList-box-zbjl-left-span1">{{data.liveStartTime}}-{{data.liveEndTime}}</span>
		</div>
		<div class="zbList-box-title" v-else>
			<div class="zbList-box-title-left">{{data.name}}</div>
			<div class="zbList-box-title-right">
				<img src="../../assets/image/zhibo_shutiao_16@2x.png" alt=""/>
				<span>{{data.onlineUserCount}}</span>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import { delLiveRecord } from '../../api/zhibo';
export default {
  name:'zbList',
  props:['data','type'],
  data() {
    return {
	  
    };
  },
  mounted() {
	
  },
  methods: {
	handleDetial(data){
		sessionStorage.setItem('isPageRefreshed', 0);
		if(this.type == 1){
			return
		}
		//this.$router.push({ path: '/zhibojian',query:{liveId:data.liveId}});
		this.$router.push({ path: '/zhibozhong',query: { 
              liveId: data.liveId,
			  
            }});
		// helpKey: 'sXsXcfWsSiGW4dgn'
	},
	handlePlayVideo(replayUrl) {
	  this.$router.push({ 
	    path: '/huifang', 
	    query: { 
	      url: replayUrl, 
	      name: this.data.name, 
	      period: this.data.period || '' 
	    } 
	  });
	},
	handleDelete(item) {
		const id = item.id || item.liveId;
		if (!id) {
			this.$message.error(this.$t('all.qingshurushuju'));
			return;
		}
		this.$confirm(this.$t('all.confirmDelete') || '确认删除该直播记录？').then(() => {
			delLiveRecord({ id }).then(res => {
				this.$message.success(res.msg || this.$t('all.shanchuchenggong') || '删除成功');
				this.$emit('delete', id);
			}).catch(err => {
				this.$message.error(err.message || '删除失败');
			});
		}).catch(() => {});
	}
  }
};
</script>
<style scoped lang="scss">
	@import "./zbList.css";
</style>


// WEBPACK FOOTER //
// zbList.vue?20480b28